var exports = {
  "x": "x93eb46d8--91af2a--button",
};

module.exports = exports;
